import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { CarrierTypeDocumentService } from 'app/services/carrier-type-document.service';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { Linked } from 'app/interfaces/linked';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { DOCUMENT_LINK_DELINK_ACTION, LINK_PERMITS_DOCUMENT_ACTIONS } from 'app/shared/actions/actions.constants';

@Component({
  selector: 'app-list-carrier-type-document',
  templateUrl: './list-carrier-type-document.component.html',
  styleUrls: ['./list-carrier-type-document.component.css']
})
export class ListCarrierTypeDocumentComponent implements OnInit {

  carrierTypes: any = [];
  selectedCarrierType: any = {};
  doctypes: any = {};
  linked: any = [];
  isChecked: boolean = false;
  refLink: any = {};
  isEdit: boolean = false;
  doctype: string = "";
  isActivated: boolean = false;
  selected = true;
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;
  page = 1;
  lblHeading = '';
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  code: any;
  description: any
  popoverTitle = 'Delete Carrier Type Document Link';
  popoverMessage = 'Are you sure you want to delete Carrier Type Document Link?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Carrier Type Document Links...";

  public isLoading = false;
  isEmpty: boolean = false;
  id: number;

  carrierUnLinkId: any
  carrierLinkId: any
  linkCode: any
  selectedUnLinkIndex: any = null;
  selectedLinkIndex: any = null;
  selectCarrierDocumentLink: any = null
  selectCarrierDocumentUnlink: any = null
  documentLinkDelinkAction = DOCUMENT_LINK_DELINK_ACTION;


  constructor(private CTDservice: CarrierTypeDocumentService, private DTservice: DocumenttypeService,
    private CTservice: CarrierTypeService, private authWebService: AuthWebService, private toastService: ToastNotificationService,
    private utility: UtilityServiceService, private toastr: ToastrService) { }

  ngOnInit() {
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.onLoadCarrierTypes()
    //this.carrierTypes =[{ id: 4, code: 'Foreign' }, { id: 1003, code: 'CTC007-587' }, { id: 1004, code: 'INDVL' }];
    this.onChangeHeading();

  }

  onLoadCarrierTypes() {
    this.isActivated = true;
    this.CTservice.getAll().subscribe(
      result => {
        this.carrierTypes = result;
        this.isActivated = false;
        //console.log(this.carrierTypes);
      },
      error => {
        //console.log(error);
        this.isActivated = false;
      });
  }

  onChange() {
    this.linked = [];
    this.isChecked = false;
    if (this.selectedCarrierType.id > 0)
      this.code = this.selectedCarrierType.code
    this.description = this.selectedCarrierType.description
    this.onReloadLinks(this.selectedCarrierType.id);
    console.log(this.selectedLinkIndex, this.selectedUnLinkIndex);
    
  }
  onReloadLinks(id: number, show: boolean = true) {
    this.message = "Loading document types, please wait...";
    this.isActivated = show;
    this.DTservice.getLinkedAndUnlinkedDoctypes(id).subscribe(
      result => {
        this.doctypes = result;
        this.isActivated = false;
        //console.log(this.doctypes.linked);
      },
      error => {
        //console.log(error);
        this.isActivated = false;
      }
    );
  }
  
  isInList(id: number) {
    let count = this.linked.length;
    for (let iter = 0; iter < count; iter++) {
      if (this.linked[iter].document_type_id == id) return iter;
    }
    return -1;
  }
  
  onCheck(id: number) {
    let val: Linked = {
      id: undefined,
      document_type_id: id,
      carrier_type_id: this.selectedCarrierType.id,
      is_active: true,
      is_mandatory: false,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    this.isChecked = true;
    let index = this.isInList(id);
    if (index == -1) this.linked.push(val);
    else this.linked[index] = val;
  }

  onPop(id: number) {
    this.isChecked = true;
    let index = this.isInList(id);
    //console.log("remove item");
    if (index != -1) this.linked.splice(index, 1);
  }


  onDelete(id: number, doctype: string) {
    //console.log(id);
    this.message = `Unlinking ${this.doctype}, please wait...`;
    this.isActivated = true;
    this.DTservice.deleteLink(id).subscribe(
      result => {
        this.isActivated = false;
        this.onReloadLinks(this.selectedCarrierType.id, false);
        // this.dialogService.addDialog(AlertComponent, { title: 'Unlink Document Type', message: `Document type ${doctype} linked to ${this.selectedCarrierType.code} unlinked succesfully.`, bold: `${this.selectedCarrierType.code}` });
        this.toastService.success(`Document type ${doctype} linked to ${this.selectedCarrierType.code} unlinked succesfully.`, 'Carrier Type Document Link');
      },
      error => {
        this.isActivated = false;
        //console.log(error);
      }
    );
  }

  OnSaveLinks(id) {
    let val: Linked = {
      id: undefined,
      document_type_id: id,
      carrier_type_id: this.selectedCarrierType.id,
      is_active: true,
      is_mandatory: false,
      date_created: new Date(),
      user_created: this.user.LastName,
      user_modified: this.user.LastName,
      date_modified: new Date()
    };
    this.message = "Linking selected document type(s), please wait...";
    this.isActivated = true;
    this.DTservice.addToLinks(val).subscribe(
      result => {
        this.isActivated = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Linking Document Type(s)', message: `Document type(s) linked to ${this.selectedCarrierType.code} succesfully.`, bold: `${this.selectedCarrierType.code}` });
        this.toastService.success(`Document type(s) linked to ${this.selectedCarrierType.code} succesfully.`, 'Carrier Type Document Link');

        this.onReloadLinks(this.selectedCarrierType.id, false);
        this.linked = [];
      },
      error => {
        //console.log(error);
        this.isActivated = false;
        this.linked = [];
      }
    );

  }
  onEdit(id: any, doctype: any) {
    this.doctype = doctype;
    this.isEdit = true;
    this.DTservice.getLinkById(id).subscribe(
      result => {
        this.refLink = result;
        this.refLink.DocumentType = doctype;
      },
      error => {
        //console.log(error);
      }
    );
  }


  onUpdateLink(event, id, carrierType) {
    //console.log(event.target.checked);
    if (event.target.checked) {
      // this.message = `Update link between ${this.doctype} and ${this.selectedCarrierType.code}, please wait...`;
      this.isActivated = true;
      let link: Linked = {
        id: id,
        document_type_id: carrierType.document_type_id,
        carrier_type_id: carrierType.carrier_type_id,
        is_active: carrierType.is_active,
        is_mandatory: true,
        date_created: carrierType.date_created,
        user_created: carrierType.user_created,//To be changed
        user_modified: carrierType.user_created,//To be changed
        date_modified: new Date()
      };

      this.DTservice.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedCarrierType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedCarrierType.code} updated succesfully.`, bold: `${this.selectedCarrierType.code}` });
          this.toastService.success(`Document type ${this.doctype} linked to ${this.selectedCarrierType.code} updated succesfully.`, 'Carrier Type Document Link');

        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }
    if (!event.target.checked) {
      //this.message = `Update link between ${this.doctype} and ${this.selectedCarrierType.code}, please wait...`;
      this.isActivated = true;
      let link: Linked = {
        id: id,
        document_type_id: carrierType.document_type_id,
        carrier_type_id: carrierType.carrier_type_id,
        is_active: carrierType.is_active,
        is_mandatory: false,
        date_created: carrierType.date_created,
        user_created: carrierType.user_created,//To be changed
        user_modified: carrierType.user_created,//To be changed
        date_modified: new Date()
      };
      //console.log(link);

      this.DTservice.updateLink(link).subscribe(
        result => {
          this.onReloadLinks(this.selectedCarrierType.id, false);
          this.isEdit = this.isActivated = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Document Type Link', message: `Document type ${this.doctype} linked to ${this.selectedCarrierType.code} updated succesfully.`, bold: `${this.selectedCarrierType.code}` });
          this.toastService.success(`Document type ${this.doctype} linked to ${this.selectedCarrierType.code} updated succesfully.`, 'Carrier Type Document Link');

        },
        error => {
          //console.log(error);
          this.isEdit = this.isActivated = false;
        }
      );
    }
  }

  checkedCarrierDocUnlink(ev: any, res, index) { // Angular 13
    this.carrierUnLinkId = res?.id
    this.selectedUnLinkIndex = ev.target.checked ? index : undefined;
    if (ev.target.checked) {
      this.selectCarrierDocumentUnlink = res;
    } else {
      this.selectCarrierDocumentUnlink = null;
    }
  }

  checkedCarrierDocLink(ev: any, optionalVal, res, index) {
    this.carrierLinkId = res?.id
    this.linkCode = res?.code
    this.selectedLinkIndex = ev.target.checked ? index : undefined;
    if (ev.target.checked) {
      this.selectCarrierDocumentLink = res;
    } else {
      this.selectCarrierDocumentLink = null;
    }

  }

  doCarrierTypeDocAction(event: any) {
    if (event.value == LINK_PERMITS_DOCUMENT_ACTIONS.Delink) {
      (this.selectCarrierDocumentUnlink == null) ? this.toastService.error('Please select the link document first!','') : this.OnSaveLinks(this.carrierUnLinkId);

    } else {
      if (event.value == LINK_PERMITS_DOCUMENT_ACTIONS.Link) {
        (this.selectCarrierDocumentLink == null) ? this.toastService.error('Please select the unlink document first!','') : this.onDelete(this.carrierLinkId, this.linkCode);
      }
    }
  }


  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Carrier Type Documents' : 'Delete Carrier Type Document';
  }
  
  onCancel() {
    this.isEdit = false;
  }



}
